<template>
  <div class="help-center-search-results__component">
    <HelpCenterSearchResult
      v-for="result of results"
      :key="result.uid"
      :result="result"
      @close="close"
    />
  </div>
</template>

<script setup>
import HelpCenterSearchResult from 'help-center/components/HelpCenterSearchResult'

const emit = defineEmits(['close'])

defineProps({
  results: {
    type: Array,
    required: true
  }
})

function close() {
  emit('close')
}
</script>

<style lang="scss">
.help-center-search-results__component {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>
